import type { Icon } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { cn } from "~/foundation/utils/cn";

export interface EmptyProps {
  icon?: Icon;
  title?: string;
  message: string;
  action?: ReactNode;
  className?: string;
}

export function Empty({ icon: IconComponent, title, message, action, className }: EmptyProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2 px-6 py-12 text-center",
        className,
      )}
    >
      {IconComponent ? (
        <IconComponent size={28} aria-hidden className="text-text-tertiary" />
      ) : null}
      {title ? <p className="text-body font-medium text-text">{title}</p> : null}
      <p className="max-w-sm text-body text-text-secondary">{message}</p>
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
